module.exports = __webpack_public_path__ + "static/media/sms.9be4128f.svg";